export default __webpack_public_path__ + "static/santa-1-291528036dead97cc0e11d5989980e3f.svg";